module.exports = __webpack_public_path__ + "img/en.6f78d5f0.svg";